import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Container = styled.div`
  padding: 16px;
`

export const Header = styled.div`
  display: flex;
  margin-right: 42px;
  color: ${colors.gray400};

  span {
    flex: 1;
  }

  span:nth-child(2) {
    flex: 0.7;
  }

  > :last-child {
    flex: 0;
    min-width: 90px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  margin-top: 20px;
`
